<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailProduitSalon.dates.titre') }}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-4">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitSalon.dates.dateSignature') }}
          </p>
          <p class="has-text-weight-bold">{{ produit.dateSignature | formatDate }}</p>
        </div>
        <div class="column is-4">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitSalon.dates.dateDebut') }}
          </p>
          <p class="has-text-weight-bold">{{ produit.dateDebut | formatDate }}</p>
        </div>
        <div class="column is-4">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitSalon.dates.dateFin') }}
          </p>
          <p class="has-text-weight-bold">{{ produit.dateFin | formatDate }}</p>
        </div>
        <div class="column is-4" v-if="produit.periodiciteId !== undefined">
          <p class="has-text-default is-italic">
            {{ $t('detailProduitPresse.periodicite') }}
          </p>
          <p class="has-text-weight-bold">{{ getPeriodiciteById(produit.periodiciteId) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'CatalogueProduitGeneralPresseDetailDates',
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    periodicites() {
      return this.parametre(PARAMETRES_KEYS.periodicite);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getPeriodiciteById(id) {
      const periodicite = this.periodicites.find((el) => el.id === id);
      if (periodicite) return periodicite.libelle;
      return '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.periodicite]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
